export let PACKAGE_PICKER_COMPONENTS = /*#__PURE__*/function (PACKAGE_PICKER_COMPONENTS) {
  PACKAGE_PICKER_COMPONENTS["FAQ"] = "FAQ";
  PACKAGE_PICKER_COMPONENTS["MARKETING_CARDS"] = "MARKETING_CARDS";
  PACKAGE_PICKER_COMPONENTS["ACCEPTED_PAYMENT_METHODS"] = "ACCEPTED_PAYMENT_METHODS";
  PACKAGE_PICKER_COMPONENTS["PRODUCTS_GRID"] = "PRODUCTS_GRID";
  return PACKAGE_PICKER_COMPONENTS;
}({});
//# sourceMappingURL=components.js.map